import { SET_BOOL_EDIT_DATA } from '../../../constants/ActionTypes';
import applicantDetailsSummaryInitialState from './applicantDetailsSummaryInitialState';

function applicantDetailsSummaryReducer(state = applicantDetailsSummaryInitialState, action) {
    switch (action.type) {
    case SET_BOOL_EDIT_DATA: {
        return {
            editData: action.editData,
        };
    }
    default:
        return state;
    }
}

export default applicantDetailsSummaryReducer;



// WEBPACK FOOTER //
// ./src/app/FormStepper/ApplicantDetailsSummary/applicantDetailsSummaryReducer.js